// This file serves as a separate entry point which can be imported without rendering the overlay
// as a side effect.

export const elementIds = {
  /**
   * ID for the root element of the overlay.
   */
  root: 'cloudpack-overlay-root',
  /**
   * ID for the root element of the error dialog.
   */
  errorDialogRoot: 'cloudpack-overlay-error-dialog',
  /**
   * ID for the root element of the status dialog.
   */
  statusDialogRoot: 'cloudpack-overlay-status-dialog',
  /**
   * ID for the title element of any dialog.
   */
  dialogTitle: 'cloudpack-overlay-dialog-title',
  /**
   * ID for the root element of the status badge.
   */
  statusBadgeRoot: 'cloudpack-overlay-status-badge',
} as const;
